import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=3341d174&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"
import style0 from "./aboutUs.css?vue&type=style&index=0&id=3341d174&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3341d174",
  null
  
)

export default component.exports